import axios from 'axios'

axios.defaults.baseURL = 'https://affyboy.com/'; 
//axios.defaults.baseURL = 'http://127.0.0.1:8000/'; 
// baseurl must end with a /
